import { createContext } from "react";

const ExperienceContext = createContext();

export default ExperienceContext;
